import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { HideModalComponent } from './hide-modal/hide-modal.component';

@Component({
  selector: 'curbnturf-hide-confirmation-modal',
  templateUrl: './hide-confirmation-modal.component.html',
  styleUrls: ['./hide-confirmation-modal.component.scss'],
  standalone: true,
  imports: [HideModalComponent, IonicModule, NgTemplateOutlet],
})
export class HideConfirmationModalComponent {
  @Input() name: string;
  @Input() hideFunction: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() template: TemplateRef<any>;

  modal: HTMLIonModalElement;

  constructor(private modalController: ModalController) {}

  async openModal() {
    this.modal = await this.modalController.create({
      component: HideModalComponent,
      componentProps: {
        name: this.name,
        confirmFunction: () => this.confirm(),
        declineFunction: () => this.closeModal(),
      },
      cssClass: 'confirm-modal center',
    });

    this.modal.present();
  }

  confirm(): void {
    this.hideFunction();

    this.closeModal();
  }

  closeModal(): void {
    this.modalController.dismiss();
  }
}
